import { clearRole, clearWorkspaceScopedSelections } from './permissions';

// Only consume sessions returned by the verified Wix handshake, never /state.
export function acceptWixEntrySession(entry) {
  if (entry?.preserve_session && !entry.token) return;
  if (!entry || (!entry.token && entry.action !== 'REGISTER')) return;
  if (entry.action !== 'REGISTER' && !entry.user_id) throw new Error('Invalid Wix account session.');
  clearWorkspaceScopedSelections();
  clearRole();
  for (const key of ['token', 'user_id', 'first_name', 'date_format', 'timezone']) localStorage.removeItem(key);
  if (entry.action === 'REGISTER') return;
  localStorage.setItem('token', entry.token);
  localStorage.setItem('user_id', String(entry.user_id));
  localStorage.setItem('first_name', entry.first_name || '');
  localStorage.setItem('date_format', entry.date_format || 'YYYY-MM-DD');
  localStorage.setItem('timezone', entry.timezone || 'UTC');
}
